<app-vault-module-shell
  moduleLabel="Reportes Generales"
  [accessDenied]="accessDenied()"
  [loadError]="loadError()"
  [loadErrorTitle]="loadErrorTitle()"
>
<section class="reports">
  <app-page-header
    title="Reportes Generales"
    subtitle="Estadísticas de preservación por paquete AIP: cada ingesta procesada genera un .zip archivado, no se cuentan documentos internos ni paquetes DIP."
    icon="Activity"
  />

  <div class="reports__toolbar">
    <div class="reports__toolbar-meta">
      <span>Actualizado: {{ formatUpdatedAt(lastUpdated()) }}</span>
    </div>
    <div class="reports__toolbar-actions">
      <app-export-format-selector
        label="Exportar"
        [options]="exportOptions"
        [disabled]="!stats()"
        (exportSelected)="onExportFormatSelected($event)"
      />
      <lib-button variant="secondary" type="button" prefixIcon="RefreshCcw" [loading]="refreshing()" (clicked)="refreshStatistics()">
        Actualizar
      </lib-button>
    </div>
  </div>

  @if (loading()) {
    <div class="reports__skeleton" aria-busy="true">
      <lib-skeleton variant="rectangle" [height]="'96px'" />
      <lib-skeleton variant="rectangle" [height]="'96px'" />
      <lib-skeleton variant="rectangle" [height]="'96px'" />
    </div>
  } @else if (!stats()) {
    <lib-empty
      icon="Activity"
      message="Sin estadísticas"
      description="No se recibieron datos de preservación para el tenant actual."
    />
  } @else {
    <section class="reports__kpis" aria-label="Resumen general de paquetes AIP">
      <article class="reports__kpi">
        <h3>Total de ingestas</h3>
        <p class="reports__kpi-value">{{ formatInt(stats()!.total_files) }}</p>
        <p class="reports__kpi-sub">Paquetes AIP (.zip) preservados</p>
        <p class="reports__kpi-sub">{{ formatSizeFromStats(stats()) }} acumulados</p>
      </article>
      <article class="reports__kpi">
        <h3>Óptimos</h3>
        <p class="reports__kpi-value reports__kpi-value--ok">{{ formatInt(stats()!.by_status.optimal) }}</p>
      </article>
      <article class="reports__kpi">
        <h3>Requieren atención</h3>
        <p class="reports__kpi-value reports__kpi-value--warn">{{ formatInt(stats()!.by_status.attention) }}</p>
      </article>
      <article class="reports__kpi">
        <h3>Críticos</h3>
        <p class="reports__kpi-value reports__kpi-value--danger">{{ formatInt(stats()!.by_status.critical) }}</p>
      </article>
    </section>

    <section class="reports__kpis reports__kpis--secondary" aria-label="Legal hold y retención">
      <article class="reports__kpi">
        <h3>Custodia legal</h3>
        <p class="reports__kpi-value">{{ formatInt(stats()!.files_with_legal_hold) }}</p>
        <p class="reports__kpi-sub">Paquetes AIP bajo legal hold</p>
      </article>
      <article class="reports__kpi">
        <h3>Retención documental</h3>
        <p class="reports__kpi-value">{{ formatInt(stats()!.files_with_retention) }}</p>
        <p class="reports__kpi-sub">Paquetes AIP con retención activa</p>
      </article>
    </section>

    <section class="reports__panel" aria-labelledby="reports-status-title">
      <h2 id="reports-status-title">Distribución por estado</h2>
      <p class="reports__panel-lead">Cantidad de paquetes AIP según su estado de preservación.</p>
      <div class="reports__status-table-wrap">
        <table class="reports__table">
          <thead>
            <tr>
              <th>Estado</th>
              <th class="is-right">Cantidad</th>
              <th class="is-right">Porcentaje</th>
            </tr>
          </thead>
          <tbody>
            @for (row of statusRows(); track row.label) {
              <tr>
                <td>{{ row.label }}</td>
                <td class="is-right">{{ formatInt(row.value) }}</td>
                <td class="is-right">{{ row.percent.toFixed(1) }}%</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="reports__panel" aria-labelledby="reports-ext-title">
      <h2 id="reports-ext-title">Top 10 extensiones del paquete AIP</h2>
      <p class="reports__panel-lead">Extensión del archivo contenedor (.zip), no de los documentos dentro de la ingesta.</p>
      <div class="reports__status-table-wrap">
        <table class="reports__table">
          <thead>
            <tr>
              <th>Extensión del paquete</th>
              <th class="is-right">Total</th>
              <th class="is-right">Óptimos</th>
              <th class="is-right">Atención</th>
              <th class="is-right">Críticos</th>
              <th class="is-right">Sin verificar</th>
            </tr>
          </thead>
          <tbody>
            @for (row of topExtensions(); track row.extension) {
              <tr>
                <td>{{ row.extension }}</td>
                <td class="is-right">{{ formatInt(row.count) }}</td>
                <td class="is-right">{{ formatInt(row.optimal) }}</td>
                <td class="is-right">{{ formatInt(row.attention) }}</td>
                <td class="is-right">{{ formatInt(row.critical) }}</td>
                <td class="is-right">{{ formatInt(row.unverified) }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  }
</section>
</app-vault-module-shell>
